export default "__VITE_PUBLIC_ASSET__91b6fa2a__"